import {fetchReportList} from '../../../services/reportServices'
import {reportListActions} from '../report'

const getReportsListAction = (payload) => {
  return (dispatch) => {
    dispatch(reportListActions.reportsListRequest())
    fetchReportList(payload).then((res) => {
      dispatch(reportListActions.reportsListSuccess(res))
    }).catch((error) => {
      dispatch(reportListActions.reportsListFailure(error))
    })

  }
}

export default getReportsListAction
